import React from "react";
import { useQuery } from "@apollo/client/react";

import { getPreferenceQuery } from "../../Queries";

function usePreferences({
  variables,
  fetchPolicy = "cache-and-network",
  skip,
}) {
  const { data, loading, networkStatus } = useQuery(getPreferenceQuery, {
    variables,
    fetchPolicy,
    skip: skip,
    context: {
      useHttpLink: true,
    },
  });

  return {
    data,
    loading,
    networkStatus,
  };
}

export default usePreferences;
